<template>
  <CryptoTable />
</template>

<script>
import CryptoTable from './components/CryptoTable.vue'

export default {
  name: 'App',
  components: {
    CryptoTable
  },

}

</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
}
</style>
